import { render, staticRenderFns } from "./il-safetyhook-lookup.vue?vue&type=template&id=2193f317"
import script from "./il-safetyhook-lookup.vue?vue&type=script&lang=ts"
export * from "./il-safetyhook-lookup.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports